import { api, type Api } from "@api/bot-base-api-request";
import { useQuery } from "@tanstack/react-query";
import { BotWalletsResponse } from "./types";

const BOT_GET_USER_INFO_QUERY_KEY = "bot-get-user-info";

type BotGetUserInfoParams = {
  appPubKey: string;
  userId: string;
};

const fetchBotUserInfo = async (
  api: Api,
  params: BotGetUserInfoParams,
): Promise<BotWalletsResponse> =>
  api.get("userInfo", { searchParams: params }).json();

const useGetBotUserInfo = (params: BotGetUserInfoParams) =>
  useQuery({
    queryKey: [BOT_GET_USER_INFO_QUERY_KEY, params],
    queryFn: async () => fetchBotUserInfo(api, params),
    enabled: !!params.userId,
  });

export { useGetBotUserInfo, fetchBotUserInfo, BOT_GET_USER_INFO_QUERY_KEY };
